// @flow
import React from 'react';
import styled from 'styled-components';

type ErrorLabelProps = {
  text: string,
}

const Label = styled.label`
  font-family: "AvenirNextLTW01-Regular";
  margin-top: 8px;
  color: red;
  font-size: 14px;
  font-weight: 600;
`;

const ErrorLabel = (props: ErrorLabelProps) => {
  const { text } = props;

  return (
    <Label>{text}</Label>);
};

export default ErrorLabel;
